import { useCallback, useEffect } from "react";

import {
  i18n,
  isValidMobile,
  routesName,
  useCounter,
  usePostLoginForgetPassword,
  usePostLoginNewPassword,
} from "core/src";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export const USERNAME='userName';
export const MOBILENUMBER = "mobileNumber";
export const NEWPASSWORD = "newPassword";
export const TYPE = "type";
export const REGISTRYCODE = "registryCode";
const useLogic = () => {


  const navigate = useNavigate();

  const methods = useForm({
    defaultValues: {
      userName:"",
      mobileNumber: "",
      registryCode: "",
      newPassword: "",
      type: "sms",
    },
  });

  const {
    register,
    handleSubmit,
    setError,
    getValues,
    formState: { errors },
  } = methods;

  const {userName, registryCode, newPassword, mobileNumber, type } = getValues();
  const {
    data: _isVerified,
    isPending: isLoadingSentCode,
    error: errorSentCode,
    mutate: refetchSentCode,
    isSuccess,
  } = usePostLoginForgetPassword();

const isVerified = isSuccess;
  
  const { counter, counterStatus, startCounter, stopCounter } = useCounter(
    60,
    0
  );
  useEffect(() => {
    if (!isVerified) {
      return;
    }

    startCounter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVerified]);
//////////////////////////////////////////////////////////////////////////////
  const {
    isPending: isLoadingRegisterToken,
    error: errorRegisterToken,
    mutate: refetchSetNewPassword,
  } = usePostLoginNewPassword({
    onSuccess: () => {
      stopCounter();
      navigate(routesName.LOGIN);
    },
    onError: () => {
      stopCounter();
    },
  });

  const isLoading = isLoadingSentCode ;

  const verifyCode = async ({
    registryCode,
    newPassword,
  }: {
    registryCode: string;
    newPassword: string;
  }) => {
    if (isLoading) {
      return;
    }

    if (!registryCode) {
      setError(REGISTRYCODE, { message: i18n.t("isRequired") }, { shouldFocus: true });
    } else if (registryCode.length < 4) {
      setError(
        REGISTRYCODE,
        { message: i18n.t("TheNewPasswordThatYouEnteredDoNotMatch") },
        { shouldFocus: true }
      );
    }
    refetchSetNewPassword({
      headerParams:{
         newPass:_isVerified?.data,

      },
      requestBody: {
        newPassword,registryCode },
    });
  };
  const forgetPassword = async ({
    userName,
    mobileNumber
  }: {
    userName:string;
    mobileNumber: string;
  }) => {
    if (!isVerified) {
      refetchSentCode({ 
        requestBody: {
           userName,
           mobileNumber
           } 
          });

      return;
    } else {
      await verifyCode({ registryCode, newPassword});
    }
  };

  const requestCode = useCallback(async () => {
    if (!mobileNumber) {
      setError(
        MOBILENUMBER,
        { message: i18n.t("isRequired") },
        { shouldFocus: true }
      );
    } else if (!isValidMobile(mobileNumber)) {
      setError(
        MOBILENUMBER,
        { message: i18n.t("enterAValidMobileNumber") },
        { shouldFocus: true }
      );
    }

    if (isLoading) {
      return;
    }

    refetchSentCode({
      requestBody: { userName,mobileNumber },
    });
  }, [ mobileNumber, newPassword ]);

  return {
    errors,
    type,
    serviceError: "",
    isLoading,
    forgetPassword,
    isVerified,
    methods,
    handleSubmit,
    register,
    counter,
    counterStatus,
    requestCode
  };
};

export { useLogic };
